import React from 'react';
import type { UseToastOptions } from '@chakra-ui/react';
import { GlassNotificationSurface } from './GlassNotificationSurface';
import { toastStatusToGlassTone } from './glassNotificationTokens';

export type GlassToastRenderProps = UseToastOptions & {
  onClose: () => void;
};

/**
 * Cuerpo de toast Chakra con estética glass; se usa vía `toastOptions.defaultOptions.render`.
 */
export function GlassToast(props: GlassToastRenderProps) {
  const { title, description, status, onClose, isClosable, icon } = props;
  const tone = toastStatusToGlassTone(status);

  return (
    <GlassNotificationSurface
      tone={tone}
      title={title ?? ''}
      description={description}
      onClose={onClose}
      isClosable={isClosable}
      customIcon={icon}
    />
  );
}
